import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useReducer,
} from 'react';
import { LeadState, GlobalAction } from '.';
import { leadReducer } from './leadReducer';

type Props = {
  children: ReactNode;
};

type ContextProps = {
  state: LeadState;
  dispatch: React.Dispatch<GlobalAction>;
};

const LeadContext = createContext({} as ContextProps);

const initialState: LeadState = {
  leads: {},
  count: 0,
  loading: true,
  order: [],
};

export const LeadContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(leadReducer, initialState);
  const value = useMemo(() => ({ state, dispatch }), [state]);
  return <LeadContext.Provider value={value}>{children}</LeadContext.Provider>;
};

export const useLeadContext = () => useContext(LeadContext);
